import React from 'react'

import type { FindDriverControllerData } from '../../../hooks/useFindDriverController'
import { Dialog } from '../../Dialog'

import styles from './style.module.css'

type Props = {
  controllerData: FindDriverControllerData
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmControllerModal: React.FC<Props> = ({
  controllerData,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    onClose={onCancel}
    prevButtonProps={{
      label: 'キャンセル',
      onClick: onCancel,
      variant: 'cancel',
    }}
    nextButtonProps={{
      label: '更新する',
      onClick: onConfirm,
      variant: 'primary',
    }}
  >
    <p className={styles.message}>
      メールアドレス「<span className={styles.value}>{controllerData.vehicleControllerEmail}</span>
      」は登録済みです。
      <br />
      配車担当者「<span className={styles.value}>{controllerData.vehicleControllerName}</span>
      」で更新しますか？
    </p>
  </Dialog>
)
